{
  "Filter": "Filtro",
  "Search": "Buscar",
  "Alarms": "Alarmas",
  "Warnings": "Advertencias",
  "Users": "Usuarios",
  "Coolers": "Refrigeradores",
  "Active License": "Licencia activa",
  "License Expired": "Licencia caducada",
  "Grace Period": "Período de gracia",
  "Tenant Users": "Usuarios inquilinos",
  "Logout": "Cerrar sesión",
  "Profile Update": "Actualizar perfil",
  "Change Passowrd": "Cambiar contraseña",
  "Change Email": "Cambiar correo electrónico",
  "Dashboard": "Panel",
  "Manage": "Administrar",
  "Rules": "Reglas",
  "License Expires On": "La licencia caduca el",
  "Report": "Informe",
  "Tenant List": "Lista de inquilinos",
  "Add Tenant": "Añadir inquilino",
  "Erp No": "N.º ERP",
  "Tenant": "Inquilino",
  "License End Date": "Fecha de finalización de la licencia",
  "Tenant Email": "Correo electrónico del inquilino",
  "ERP Number": "Número ERP",
  "Maximum number of coolers": "Número máximo de refrigeradores",
  "License Expiration": "Caducidad de la licencia",
  "Tenant Details": "Detalles del inquilino",
  "TENANT EMAIL": "CORREO ELECTRÓNICO DEL INQUILINO",
  "COOLERS": "REFRIGERADORES",
  "Expire": "CADUCIDAD",
  "GEO LOCATION": "GEOLOCALIZACIÓN",
  "ERP NO": "N.º ERP",
  "UPDATE": "ACTUALIZAR",
  "Disable Tenant": "Deshabilitar inquilino",
  "Move Coolers": "MOVER REFRIGERADORES",
  "Do you really want to disable": "¿De verdad quieres desactivar",
  "Cooler List": "Lista de refrigeradores",
  "Search works on COOLER, COUNTRY, TAG/ALIAS columns only": "La búsqueda solo funciona en las columnas REFRIGERADOR, PAÍS y ETIQUETA/ALIAS",
  "Cooler": "Refrigerador",
  "Last Connected": "Última conexión",
  "Country": "País",
  "Tag/Alias": "Etiqueta/Alias",
  "User Information": "Información del usuario",
  "Add New User": "Agregar usuarios nuevos",
  "Search works on ROLE, EMAIL, CREATE ALARMS, ACCESS TO columns only": "La búsqueda solo funciona en las columnas ROL, CORREO ELECTRÓNICO, CREAR ALARMAS y ACCESO A",
  "Role": "Papel",
  "Email": "Correo electrónico",
  "Create Alarms": "Crear alarmas",
  "Access To": "Acceso a",
  "Add User Details": "Agregar detalles del usuario",
  "Edit User Details": "Editar detalles del usuario",
  "All Countries Selected": "Todos los países seleccionados",
  "Yes": "Sí",
  "No": "No",
  "Alarm Information": "Información sobre alarmas",
  "Search works on UID, STATUS, COOLER, GEO LOCATION, RULE, ALARM TYPE, RESOURCE columns only": "La búsqueda solo funciona en las columnas UID, ESTADO, REFRIGERADOR, GEOLOCALIZACIÓN, TIPO DE ALARMA y RECURSO",
  "UID": "UID",
  "Geo Location": "Geolocalización",
  "Status": "Estado",
  "Alarm Type": "Tipo de alarma",
  "Rule": "Regla",
  "Resource": "Recurso",
  "Alarm Rules": "Reglas de alarmas",
  "Add New Rule": "Agregar nuevas reglas",
  "Search works on ID, STATUS, ALARM NAME, SEVERITY columns only": "La búsqueda solo funciona en las columnas ID, ESTADO, NOMBRE DE ALARMA y GRAVEDAD",
  "All": "Todo",
  "All Controller with Geo Location": "Todos los controladores con geolocalización",
  "ID": "ID",
  "Alarm Name": "Nombre de la alarma",
  "Limit": "Límite",
  "Severity": "Gravedad",
  "BACK": "ATRÁS",
  "Last Connected On": "Última conexión el",
  "Resources Data": "Datos de recursos",
  "Tag Name": "Nombre de etiqueta",
  "Update Tag or Alias Name": "Actualizar etiqueta o nombre de alias",
  "Update": "Actualizar",
  "Export": "Exportar",
  "DAY": "DÍA",
  "WEEK": "SEMANA",
  "MONTH": "MES",
  "Loading latest telemetry data ... ": "Cargando datos de telemetría más recientes... ",
  "Loading telemetry data ... ": "Cargando datos de telemetría ...",
  "No Data to display": "No hay datos para mostrar",
  "Resources": "Recursos",
  "Min": "Mín",
  "Max": "Máx",
  "Value": "Valor",
  "Timestamp": "Marca de tiempo",
  "Save": "Salvar",
  "Cancel": "Cancelar",
  "Save and Apply": "Guardar y aplicar",
  "Move": "Moverse",
  "Add Alarm Details": "Agregar detalles de la alarma",
  "Update Alarm Details": "Actualizar detalles de la alarma",
  "Controller": "Controlador",
  "Limits": "Límites",
  "Notified To": "Notificado a",
  "Apply To": "Aplicar a",
  "Max Distance": "Distancia máxima",
  "Controller Name": "Nombre del controlador",
  "All Controller In": "Todos los controladores en",
  "High": "Alto",
  "Low": "Bajo",
  "Parameters": "Parámetros",
  "Parameter": "Parámetro",
  "Select Controller": "Seleccionar controlador",
  "Select Controllers": "Seleccionar controladores",
  "Select Resource": "Seleccionar recurso",
  "Success Message": "Mensaje de proceso correcto",
  "Error": "Error",
  "Are you sure to Delete User?": "¿Está seguro de que desea eliminar el usuario?",
  "User deleted successfully.": "Usuario eliminado correctamente.",
  "Invalid Email": "Correo electrónico no válido",
  "Email field should not be empty.": "El campo de correo electrónico no puede estar vacío.",
  "Email entered is not a valid email.": "El correo electrónico introducido no es un correo válido.",
  "Invalid Role": "Rol no válido",
  "Select a role.": "Seleccione un rol.",
  "Updated successfully.": "Actualizado con éxito",
  "added successfully.": "agregado exitosamente.",
  "Error occurred while adding user, please try again.": "Error al agregar el usuario. Vuelva a intentarlo.",
  "Invalid Controller": "Controlador no válido",
  "Select a Controller": "Seleccione un controlador",
  "Invalid Resource": "Recurso no válido",
  "Select a Resource": "Seleccione un recurso",
  "Invalid Min Value": "Valor mínimo no válido",
  "Enter a valid Min Value.": "Introduzca un valor mínimo válido.",
  "Invalid Max Value": "Valor máximo no válido",
  "Enter a valid Max Value.": "Introduzca un valor máximo válido.",
  "Invalid Max Distance Value": "Valor de distancia máxima no válido",
  "Enter a valid Max Distance Value.": "Introduzca un valor de distancia máxima válido.",
  "Invalid Notify Mail Ids": "ID de correo de notificación no válidos",
  "Enter valid mail Ids.": "Introduzca ID de correo válidos.",
  "Select a valid controller in apply to section.": "Seleccione un controlador válido en la sección Aplicar a.",
  "Invalid Countries": "Países no válidos",
  "Select one or more countries apply to section.": "Seleccione uno o más países en la sección Aplicar a.",
  "Invalid Rule Name": "Nombre de regla no válido",
  "Enter a valid rule name.": "Introduzca un nombre de regla válido.",
  "added successfully": "agregado exitosamente",
  "updated successfully": "actualizado con éxito",
  "Error occurred while adding/updating Rule, please try again.": "Error al agregar/actualizar la regla. Vuelva a intentarlo.",
  "Activated successfully": "Activada exitosamente",
  "Deactivated successfully": "Desactivado exitosamente",
  "Deleted successfully.": "Borrado exitosamente.",
  "Are you sure to Delete Rule?": "¿Está seguro de que desea eliminar la regla?",
  "Invalid TenantName": "Nombre de inquilino no válido",
  "Tenant Name field should not be empty.": "El nombre de inquilino no puede estar vacío.",
  "Invalid ERP No": "N.º ERP no válido",
  "ERP NO field should not be empty.": "El campo N.º ERP no puede estar vacío.",
  "Invalid CoolersCount": "Valor de CoolersCount no válido",
  "Please enter valid Coolers": "Introduzca refrigeradores válidos",
  "Invalid Cooler Value": "Valor de refrigerador no válido",
  "Enter a valid Cooler Number Value.": "Introduzca un número de refrigerador válido.",
  "Invalid Expiry Date": "Fecha de caducidad no válida",
  "Please select Expiry Date": "Seleccione la fecha de caducidad",
  "Tenant added successfully.": "Inquilino agregado correctamente.",
  "Error occurred while adding tenant, please try again.": "Error al agregar el inquilino. Vuelva a intentarlo.",
  "Tenant Updated successfully.": "Inquilino actualizado correctamente.",
  "Error occurred while updating tenant, please try again.": "Error al actualizar inquilino. Vuelva a intentarlo.",
  "Reports": "Informe",
  "Search works on Erp No, Tenant, Geo Location only": "buscar palabras sólo en Erp No, Tenant y Geo Location",
  "Update Tenant": "Actualizar Tenant",
  "Select Expiry License Date": "Seleccionar fecha de caducidad de la licencia",
  "Registered Tenant": "Tenant registrados",
  "Registered Users": "Usuarios registrados",
  "Users under Tenant": "Usuarios contenidos en Tenant",
  "Renewal notification sent to Tenant": "Notificaciones de renovación enviadas a Tenant",
  "Number of coolers under Tenant": "Número de coolers contenidos en Tenant",
  "Date": "Fecha",
  "Choose Format": "Elegir formato",
  "Generate Report": "Generar informe",
  "Select": "Seleccionar",
  "Active Alarms": "Alarmas activas",
  "Associated Resources": "Recursos asociados",
  "Associated Users": "Usuarios asociados",
  "Coolers List": "Lista de coolers",
  "Device": "Dispositivo",
  "User Device Information": "Información sobre dispositivo del usuario",
  "Mobile Name": "Nombre de móvil",
  "Mobile Model": "Modelo de móvil",
  "Legal": "Aviso legal",
  "Privacy Policy": "Política de privacidad",
  "Copyright": "Copyright",
  "No Records found": "No se encontrarón archivos",
  "Billing Address": "Dirección de Envio",
  "Search works on Email, Mobile Name, Mobile Model": "La búsqueda funciona con correo electrónico, nombre de teléfono móvil y modelo móvil.",
  "Are you sure to Delete ?": "¿Está seguro de eliminar?",
  "No results found!": "¡No se han encontrado resultados!",
  "Select Country": "seleccionar país",
  "Start Date": "Fecha de inicio",
  "End Date": "Fecha final",
  "Select Start Date": "Seleccionar fecha de inicio",
  "Select End Date": "Seleccionar fecha de finalización",
  "Invalid Start Date": "Fecha de inicio inválida",
  "Invalid End Date": "Fecha de finalización inválida",
  "Invalid Controllers List": "Lista de controladores no válidos",
  "Please wait report is getting ready for Download": "Por favor espere el informe se está preparando para descargar",
  "downloadFaild": "Faild para descargar",
  "Format": "Formato",
  "Controllers": "Controladores",
  "Downloads in Progress": "Descargas en curso",
  "Do you agree?": "Estás de acuerdo ?",
  "All the files downloaded Successfully": "Todos los archivos descargados con éxito",
  "No files found": "No se encontraron archivos",
  "You have cancelled the Downloads": "Has cancelado las descargas",
  "Warning": "Advertencia",
  "Driver Manager": "Gerente de conductor",
  "Driver File Name": "Nombre del archivo del controlador",
  "Mask": "Máscara",
  "Uploaded By": "Subido por",
  "Uploaded On": "Subido en",

  "Are you sure to Delete Driver?": "¿Está seguro de eliminar el controlador?",
  "Please upload a valid file": "Sube un archivo válido",
  "Driver file already exists": "El archivo del controlador ya existe",
  "Are you sure you want to Overwrite?": "¿Estás seguro de que deseas sobrescribir?",
  "Download Success!": "Descargar Success!",
  "File Deleted Successfully": "Archivo eliminado con éxito",
  "Trying to upload a non verified driver": "Intentando cargar un controlador no verificado",
  "Driver File Uploaded": "Archivo de controlador cargado",
  "File name should not be more than 50 characters": "El nombre del archivo no debe tener más de 50 caracteres.",
  "Unit": "Unidad",
  "Action": "Acción",
  "Bad Request": "Solicitud incorrecta",
  "Invalid input fields": "Campos de entrada inválidos",
  "Invalid Tag Name": "Nombre de etiqueta inválido",
  "Coolers by Country": "Enfriadores por país",
  "Enable/Disable": "Habilitar deshabilitar",
  "Actions": "Acciones",
  "Controller Model": "Modelo de controlador",
  "Selected Resources Data": "Datos de recursos seleccionados",
  "Last 24Hr": "Últimas 24 horas",
  "View Data": "Ver datos",
  "Note: Maximum of 8 resources are allowed to view data": "Nota: Se permite un máximo de 8 recursos para ver datos",
  "Get Data": "Obtener datos",
  "Until": "Hasta",
  "Tag Updated Successfully": "Etiqueta actualizada correctamente",
  "Add Tag Name..": "Agregar nombre de etiqueta ...",
  "Select Tenant": "Seleccionar inquilina",
  "Tenant Disabled Successfully.": "Inquilino deshabilitado con éxito.",
  "Cooler moved successfully.": "El enfriador se movió con éxito.",
  "Unknown error occurred, Please try again.": "Se produjo un error desconocido. Vuelve a intentarlo.",
  "No cooler/coolers availabe to move": "No hay enfriador / enfriador disponible para mover",
  "The target Tenant does not have enough space for the new coolers": "El inquilino objetivo no tiene suficiente espacio para el nuevo refrigerador.",
  "Tenant is not selected": "El inquilino no está seleccionado",
  "Please select Tenant": "Por favor seleccione Inquilino",
  "Select Countries": "Seleccione paises",
  "Country List": "Lista de países",
  "Controller List": "Lista de controladores",
  "Notified Email To": "Correo electrónico notificado a",
  "Close": "Cerca",
  "Disable": "Inhabilitar",
  "Note: Once disabled you can not enable again.": "Nota: Una vez deshabilitado, no puede habilitarlo nuevamente.",
  "Delete  Rule": "Eliminar regla",
  "Delete Device": "Eliminar dispositivo",
  "Ok": "Ok",
  "Hi": "Hola",
  "Commandes": "Comandos",
  "Access Restricted Notice!": "Aviso de acceso restringido",
  "Your License has expired. Please Contact your Admin.": "Su licencia ha caducado. Póngase en contacto con su administrador.",
  "Online": "En línea",
  "Offline": "Sin conexión",
  "Total": "Total",
  "Processing...": "Procesando...",
  "Request Process Successfully": "Solicitud procesada correctamente",
  "Error occurred while processing request, please try again.": "Error al procesar la solicitud. Vuelva a intentarlo.",
  "Menu": "Menu",
  "Device Groups": "Grupos de dispositivos",
  "HACCP Report": "HACCP Report",
  "Statistics": "Estadísticas",
  "Device List": "Lista de dispositivos",
  "All Devices": "Todos los dispositivos",
  "Search works on Device, Groups, Alarms, Country columns": "La búsqueda funciona en las columnas Dispositivo, Grupos, Alarmas y País",

  "Dongle UId": "UID de llave",
  "Active": "Activo",
  "InActive": "Inactivo",
  "Group(s)": "Grupo(s)",
  "Device Details": "Detalles del dispositivo",
  "View Value": "Ver valor",
  "Group Name": "Nombre del grupo",
  "Device Name": "Nombre del dispositivo",
  "Description": "Descripción",
  "Created Date (UTC)": "Fecha de creación (UTC)",
  "Added By": "Agregado por",
  "Search works on Group Name, Description columns": "La búsqueda funciona en las columnas Nombre del grupo y Descripción",
  "Add Group Details": "Agregar detalles del grupo",
  "Edit Group Details": "Editar detalles del grupo",
  "Name of the Group": "Nombre del grupo",
  "Create New Group": "Crear nuevo grupo",

  "Select Devices": "Seleccionar dispositivos",
  "Group Information": "Información del grupo",
  "Add Description": "Agregar descripción",
  "Device Count": "Recuento de dispositivos",
  "Alarm Count": "Recuento de alarmas",
  "Device Status": "Estado del dispositivo",
  "Groups Count": "Recuento de grupos",
  "Device by Group": "Dispositivo por grupo",
  "Alarms By Device Status": "Alarmas por estado del dispositivo",
  "Device Status Count": "Recuento de estados del dispositivo",
  "Alarms By Devices Over Time": "Alarmas por dispositivos a lo largo del tiempo",
  "Real Time": "Tiempo real",
  "Last 24 Hrs": "Últimas 24 horas",
  "Last Week": "Última semana",
  "Last Month": "Último mes",
  "Last 3 Months": "Últimos 3 meses",
  "Last 1 Year": "Último año",
  "Last 6 Months": "Últimos 6 meses",
  "Devices": "Dispositivos",
  "OEM": "OEM",
  "Name": "Nombre",
  "OEM\/Parent": "OEM\/matriz",

  "Create Users": "Crear usuarios",
  "Selected Countries": "Países seleccionados",
  "Selected Devices": "Dispositivos seleccionados",
  "Enabled": "Habilitado",
  "Disabled": "Deshabilitado",
  "Groups": "Grupos",
  "Groups List": "Lista de grupos",
  "Select Groups": "Seleccionar grupos",
  "Telemetry": "Telemetría",
  "Filters": "Filtri",
  "Show Favorites": "Mostrar favoritos",
  "Favorites": "Favoritos",
  "Favourites": "Favoritos",
  "Label": "Etiqueta",
  "Current Value": "Valor actual",
  "Operations": "Operaciones",
  "Read All": "Leer todo",
  "Settings": "Ajustes",
  "Set Value": "Establecer valor",
  "Mobile UId": "UID móvil",
  "Mobile OS | Version": "SO móvil | Versión",
  "Issued On": "Emitido el",
  "Active Device(s)": "Dispositivo(s) activo(s)",
  "In-active Device(s)": "Dispositivo(s) inactivo(s)",
  "Block User": "Bloquear usuario",
  "Unblock User": "Desbloquear usuario",
  "Driver Upload": "Carga de controladores",
  "Search works on Driver File Name, Mask, and Uploaded By columns": "La búsqueda funciona en las columnas Nombre del archivo de controlador, Máscara y Cargado por",
  "Add new report": "Agregar nuevo informe",
  "Report Name": "Nombre del informe",
  "Report Frequency": "Frecuencia del informe",
  "Daily": "Diaria",
  "Weekly": "Semanal",
  "Monthly": "Mensual",
  "Data Frequency": "Frecuencia de datos",
  "PDF": "PDF",
  "CSV": "CSV",
  "XLSX": "XLSX",
  "Delete Report :": "Eliminar informe:",
  "Add Report": "Agregar informe",
  "Update Report Details": "Actualizar detalles del informe",
  "Select Data Frequency": "Seleccionar frecuencia de datos",
  "One time per day": "Una vez al día",
  "Two times per day": "Dos veces al día",
  "Three time per day": "Tres veces al día",
  "Four times per day": "Cuatro veces al día",
  "Select Device": "Seleccionar dispositivo",
  "Data Frequency is Mandatory": "El campo Frecuencia de datos es obligatorio",
  "Device is Mandatory": "El campo Dispositivo es obligatorio",
  "Resource is Mandatory": "El campo Recurso es obligatorio",
  " Notified to email is Mandatory": " El campo Notificado a correo electrónico es obligatorio",
  "Maximum 8 resources can be selected": "Es posible seleccionar un máximo de 8 recursos",
  "Invalid OEM": "OEM no válido",
  "Select an OEM": "Seleccione un OEM",
  "User already exist": "El usuario ya existe",
  "Email or Role is not valid": "El correo electrónico o el puesto no es válido",
  "You are currently blocked. Please contact system administrator for details or to restore access. <System Admin EMAIL ID>": "Actualmente está bloqueado. Póngase en contacto con el administrador del sistema para obtener más información o restaurar el acceso. <System Admin EMAIL ID> (<ID de CORREO ELECTRÓNICO del administrador del sistema>)",
  "Invalid Device": "Dispositivo no válido",
  "Invalid Group": "Grupo no válido",
  "Error Deleting Alarm Rule": "Error al eliminar la regla de alarmas",
  "Are you sure to Block ?": "¿Está seguro de que desea bloquearlo?",
  "Are you sure to Unblock ?": "¿Está seguro de que desea desbloquearlo?",
  "Error downloading driver file": "Error al descargar el archivo del controlador",
  "Group deleted successfully": "Grupo eliminado correctamente",
  "Failed to delete group": "Error al eliminar el grupo",
  "Group created successfully": "Grupo creado correctamente",
  "Group details updated successfully": "Detalles del grupo actualizados correctamente",
  "Failed to create\/edit group": "Error al crear\/editar el grupo",
  "Group Name already exist": "El nombre del grupo ya existe",
  "Group Name already exist\/duplicate Group Name": "El nombre del grupo ya existe\/nombre del grupo duplicado",
  "Model is not valid": "El modelo no es válido",
  "Name\/Desc is not valid": "El nombre o desc. no son válidos",
  "One\/More selcted device is invalid or the user doesn't have access": "Uno o más dispositivos seleccionados no son válidos o el usuario no tiene acceso",
  "User has no access to the group": "El usuario no tiene acceso al grupo",
  "Failed to fetch data": "Error al recuperar los datos",
  "Error deleting file ": "Error al eliminar el archivo ",
  "Error occurred while adding\/updating Report, please try again.": "Error al agregar\/actualizar el informe. Vuelva a intentarlo.",
  "Are you sure to Delete Report?": "¿Está seguro de que desea eliminar el informe?",
  "Error Deleting Report": "Error al eliminar el informe",
  "User has no access to the Haccp Report": "El usuario no tiene acceso al informe HACCP",
  "Report name is not valid": "El nombre del informe no es válido",
  "Invalid Controller type": "Tipo de controlador no válido",
  "Duplicate report name": "Nombre del informe duplicado",
  "Support": "Apoyo",
  "FAQ's": "FAQ's",
  "History": "Historia",
  "Version": "Versione",
  "v3.2": "v3.2",
  "Terms and Conditions": "Términos y condiciones",
  "Search works on OID,OEM Name,OEM Description": "La búsqueda funciona en OID, nombre OEM, descripción OEM",
  "OEM Description": "descripción OEM",
  "OEM Name": "nombre OEM",
  "OID": "OID",
  "Home": "Hogar",
  "Management": "Gestión",
  "Data Export": "Exportación de datos",
  "Phone/Tablet": "Teléfono/Tableta",
  "Add OEM": "Añadir OEM",
  "Upload": "Subir",
  "Map View": "Vista del mapa",
  "Count": "Contar",
  "Added On": "Añadido el",
  "Modbus slave ID": "ID de esclavo Modbus",
  "Controller Type Name": "Nombre de tipo de controlador",
  "Device Type": "Tipo de dispositivo",
  "Group Count": "Recuento de grupos",
  "Day": "Día",
  "Hour": "Hora",
  "Start": "Inicio",
  "End": "Fin",
  "Poli": "Poli",
  "Search works on Report Name,Report Frequency, and Notified Email columns": "La búsqueda funciona en las columnas Nombre del informe, Frecuencia del informe y Correo electrónico notificado",
  "Release": "Liberar",
  "PCH": "PCH",
  "Location": "ubicación",
  "Dsp Id": "Id Dsp",
  "Firmware Version": "Versión del firmware",
  "Device Metadata": "Metadatos del dispositivo",
  "Alarms count by device's status": "Recuento de alarmas por estado del dispositivo",
  "Alarms count group by device's status and device": "Grupo de recuento de alarmas por estado del dispositivo y dispositivo",
  "Alarm Count distribution over time": "Distribución del recuento de alarmas en el tiempo",
  "Alarm status count over time": "Recuento del estado de alarma en el tiempo",
  "Device by Controller Model": "Dispositivo por modelo de controlador",
  "Select columns": "Seleccionar columnas",
  "columns selected": "columnas seleccionadas",
  
  "Language Selection": "Selección de idioma",
  "Select Language": "Seleccionar idioma"
}
